//export default {'front.rest.api.url': 'http://herramienta-centralizada-sigc.desarrollo.guadaltel.es/hcsigc/api'};
export const url_rest = "https://maps.andalucia.org/rest-turistico-fitur/rest"

export const greating = {
  es: "Bienvenido a",
  en: "Welcome to",
  fr: "Bienvenue à",
  de: "Herzlich willkommen bei"
}

export const back_label = {
  es: "Volver",
  en: "Go back",
  fr: "Retour",
  de: "Zurück"
}

export const about_us = {
  es: "¿Quiénes somos?",
  en: "Who are we?",
  fr: "Qui sommes?",
  de: "Wer sind wir?"
}

export const image_gallery = {
  es: "Galería de imágenes",
  en: "Image gallery",
  fr: "Galerie d'images",
  de: "Galerie der bilder"
}

export const where_are_we = {
  es: "¿Dónde nos encontramos?",
  en: "Where are we?",
  fr: "Ou sommes nous?",
  de: "Wo sind wir?"
}

export const languages = {
  es: { es: "Español", en: "Inglés", fr: "Francés", de: "Alemán" },
  en: { es: "Spanish", en: "English", fr: "French", de: "German" },
  fr: { es: "Espagnol", en: "Anglais", fr: "Français", de: "Allemand" },
  de: { es: "Spanisch", en: "Englisch", fr: "Französisch", de: "Deutsch" }
}

// var types2 =types
// var promises = []
// Object.keys(types).forEach(function(key) {
//     promises.push(postRequest(url_rest + "/resource_type/paginated", {
//         "item_number": 0,
//         "page_size": 20,
//         "filters": {
//         "code": key
//         }
//     }, 'multi').then(
//         (response) => {
//         types2[key].label.es = response.data.list[0].name_es
//         types2[key].label.en = response.data.list[0].name_en
//         types2[key].label.fr = response.data.list[0].name_fr
//         types2[key].label.de = response.data.list[0].name_de

//         types2[key].slug.es = response.data.list[0].slug_es
//         types2[key].slug.en = response.data.list[0].slug_en
//         types2[key].slug.fr = response.data.list[0].slug_fr
//         types2[key].slug.de = response.data.list[0].slug_de

//         // console.log('hola',response.data.list[0])
//         }));

// });
// Promise.all(promises).then(responses => {
//     console.log(types2)
// })


export const types = {
  "TIPRECAGEVIA": {
    "icon": "fa-suitcase-rolling",
    "label": {
      "es": "Agencias de Viajes",
      "en": "Tour Operators and Travel Agencies",
      "fr": "Tour Opérateur et Agences de voyages",
      "de": "Reiseveranstalter und Büros"
    },
    "slug": {
      "es": "agencias-de-viajes",
      "en": "tour-operators-and-travel-agencies",
      "fr": "tour-operateur-et-agences-de-voyages",
      "de": "reiseveranstalter-und-buros"
    }
  },
  "TIPRECALOJAM": {
    "icon": "fa-building",
    "label": {
      "es": "Alojamientos",
      "en": "Accommodations",
      "fr": "Hébergement",
      "de": "Unterkünfte"
    },
    "slug": {
      "es": "alojamientos",
      "en": "acommodation",
      "fr": "hebergements",
      "de": "unterkuenfte"
    }
  },
  "TIPRECAREANATURAL": {
    "icon": "fa-tree",
    "label": {
      "es": "Áreas Naturales",
      "en": "Nature Areas",
      "fr": "Espaces naturels",
      "de": "Naturgebiete"
    },
    "slug": {
      "es": "espacios-naturales",
      "en": "natural-spaces",
      "fr": "espaces-naturels",
      "de": "naturraeume"
    }
  },
  "TIPRECVISITA": {
    "icon": "fa-map-signs",
    "label": {
      "es": "Visitas",
      "en": "Visits",
      "fr": "Visites",
      "de": "Besuche"
    },
    "slug": {
      "es": "turismo-cultural",
      "en": "cultural-tourism",
      "fr": "tourisme-culturel",
      "de": "kultureller-tourismus"
    }
  },
  "TIPRECEVENTO": {
    "icon": "fa-calendar-alt",
    "label": {
      "es": "Eventos",
      "en": "Events",
      "fr": "Événements",
      "de": "Vranstaltungen"
    },
    "slug": {
      "es": "eventos",
      "en": "events-calendar",
      "fr": "agenda-devenements",
      "de": "veranstaltungskalender"
    }
  },
  "TIPRECEVEPROF": {
    "icon": "fa-calendar-alt",
    "label": {
      "es": "Eventos profesionales",
      "en": "Professional events",
      "fr": "Événements professionnels",
      "de": "Professionelle Veranstaltungen"
    },
    "slug": {
      "es": "eventos-profesionales",
      "en": "professional-events",
      "fr": "evenements-professionnels",
      "de": "professionelle-veranstaltungen"
    }
  },
  "TIPRECRUTATURIS": {
    "icon": "fa-route",
    "label": {
      "es": "Rutas Turísticas",
      "en": "Touristic Routes",
      "fr": "Itinéraires Touristiques",
      "de": "Touristische Routen"
    },
    "slug": {
      "es": "rutas",
      "en": "routes",
      "fr": "routes",
      "de": "routen"
    }
  },
  "TIPRECFLAMENCO": {
    "icon": "fa-guitar",
    "label": {
      "es": "Flamenco",
      "en": "Flamenco",
      "fr": "Flamenco",
      "de": "Flamenco"
    },
    "slug": {
      "es": "flamenco",
      "en": "flamenco",
      "fr": "flamenco",
      "de": "flamenco"
    }
  },
  "TIPRECCOMPRA": {
    "icon": "fa-shopping-bag",
    "label": {
      "es": "Compras",
      "en": "Shopping",
      "fr": "Achats",
      "de": "Einkäufe"
    },
    "slug": {
      "es": "ocio-y-diversion-compras",
      "en": "leisure-and-fun-shopping",
      "fr": "loisirs-et-divertissement-shopping",
      "de": "freizeit-und-vergnuegen-shopping"
    }
  },
  "TIPRECCONVCONG": {
    "icon": "fa-landmark",
    "label": {
      "es": "Conferencias y Congresos",
      "en": "Conferences and Congresses",
      "fr": "Conférences et Congrès",
      "de": "Konferenzen und Kongresse"
    },
    "slug": {
      "es": "reuniones-y-congresos",
      "en": "reuniones-y-congresos",
      "fr": "meetings-and-congresses",
      "de": "reunions-et-congres"
    }
  },
  "TIPRECACTGUI": {
    "icon": "fa-flag",
    "label": {
      "es": "Empresas de actividades guiadas",
      "en": "Guided activities companies",
      "fr": "Activités guidées entreprises",
      "de": "Geführte Aktivitäten Unternehmen"
    },
    "slug": {
      "es": "actividades-guiadas",
      "en": "guided-tours",
      "fr": "visites-guidees",
      "de": "organisierte-und-begleitete-touren"
    }
  },
  "TIPRECESCESP": {
    "icon": "fa-chalkboard-teacher",
    "label": {
      "es": "Escuelas de español para extranjeros",
      "en": "Spanish language schools",
      "fr": "Écoles d'espagnol pour étrangers",
      "de": "Spanischschulen für Ausländer"
    },
    "slug": {
      "es": "aprender-espanol-en-andalucia",
      "en": "learn-spanish-andalusia",
      "fr": "apprenez-lespagnol-en-andalousie",
      "de": "spanischunterricht-andalusien"
    }
  },
  "TIPRECGOLF": {
    "icon": "fa-golf-ball",
    "label": {
      "es": "Golf",
      "en": "Golf",
      "fr": "Golf",
      "de": "Golf"
    },
    "slug": {
      "es": "golf",
      "en": "golf",
      "fr": "golf",
      "de": "golf"
    }
  },
  "TIPRECOCIONOCTURNO": {
    "icon": "fa-cocktail",
    "label": {
      "es": "Ocio nocturno",
      "en": "Nightlife",
      "fr": "Loisirs nocturnes",
      "de": "Nachtleben"
    },
    "slug": {
      "es": "ocio-y-diversion-salir-de-noche",
      "en": "leisure-and-fun-nightlife",
      "fr": "loisirs-et-divertissement-sortir-le-soir",
      "de": "freizeit-und-vergnuegen-nachtleben"
    }
  },
  "TIPRECOFERTA": {
    "icon": "fa-tag",
    "label": {
      "es": "Ofertas",
      "en": "Offers",
      "fr": "Offres",
      "de": "Angebote"
    },
    "slug": {
      "es": "ofertas",
      "en": "deals",
      "fr": "offres",
      "de": "angebote"
    }
  },
  "TIPRECOTRCOM": {
    "icon": "fa-store-alt",
    "label": {
      "es": "Otros Comercializadores",
      "en": "Other Marketers",
      "fr": "Autres distributeurs",
      "de": "Andere Anbieter"
    },
    "slug": {
      "es": "tipos-otros-comercializadores",
      "en": "types-other-marketers-2",
      "fr": "types-autres-distributeurs-2",
      "de": "types-andere-anbieter-2"
    }
  },
  "TIPRECPARQUESOCIO": {
    "icon": "fa-swimming-pool",
    "label": {
      "es": "Parques de Ocio",
      "en": "Leisure Parks",
      "fr": "Parcs de loisirs",
      "de": "Freizeitparks"
    },
    "slug": {
      "es": "ocio-y-diversion-parques-de-ocio",
      "en": "leisure-and-fun-leisure-parks",
      "fr": "loisirs-et-divertissement-parcs-de-loisirs",
      "de": "freizeit-und-vergnuegen-freizeitparks"
    }
  },
  "TIPRECPLAYA": {
    "icon": "fa-umbrella-beach",
    "label": {
      "es": "Playas",
      "en": "Beaches",
      "fr": "Plages",
      "de": "Strände"
    },
    "slug": {
      "es": "playas",
      "en": "sun-and-beaches",
      "fr": "soleil-et-plage",
      "de": "sonne-und-strand"
    }
  },
  "TIPRECRESTAUR": {
    "icon": "fa-utensils",
    "label": {
      "es": "Restaurantes",
      "en": "Restaurants",
      "fr": "Restaurants",
      "de": "Restaurants"
    },
    "slug": {
      "es": "gastronomia",
      "en": "where-to-eat",
      "fr": "ou-manger",
      "de": "wo-sollen-wir-essen"
    }
  },
  "TIPRECSALUDBELLEZA": {
    "icon": "fa-spa",
    "label": {
      "es": "Salud y Belleza",
      "en": "Health and Beauty",
      "fr": "Santé et beauté",
      "de": "Gesundheit und Schönheit"
    },
    "slug": {
      "es": "salud-y-belleza",
      "en": "health-and-beauty",
      "fr": "sante-et-beaute",
      "de": "gesundheit-und-schonheit"
    }
  },
  "TIPRECTRANSPORTE": {
    "icon": "fa-bus",
    "label": {
      "es": "Transportes",
      "en": "Transports",
      "fr": "Transports",
      "de": "Transports"
    },
    "slug": {
      "es": "como-llegar",
      "en": "how-to-get-there",
      "fr": "comment-arriver",
      "de": "wie-finden"
    }
  },
  "TIPRECDEPORTE": {
    "icon": "fa-hiking",
    "label": {
      "es": "Turismo activo",
      "en": "Active turism",
      "fr": "Tourisme actif",
      "de": "Aktivtourismus"
    },
    "slug": {
      "es": "turismo-y-deporte",
      "en": "sports",
      "fr": "sports",
      "de": "sport"
    }
  },
  "TIPRECSERVINF": {
    "icon": "fa-info-circle",
    "label": {
      "es": "Servicios de información",
      "en": "Tourist Information",
      "fr": "Information touristique",
      "de": "Touristeninformation"
    },
    "slug": {
      "es": "servicios-de-informacion",
      "en": "tourist-information",
      "fr": "information-touristique",
      "de": "touristeninformation"
    }
  }
}



// WEBPACK FOOTER //
// ./src/configuration.js